<template>
  <input
    ref="fieldSize"
    :type="type"
    :placeholder="placeholder"
    :class="className"
    :value="value"
    @keypress="onlyNumbers"
    @change="emitChange"
  />
</template>

<script>
export default {
  props: ["type", "placeholder", "className", "value"],
  methods: {
    onlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      const isNotNumber = charCode < 48 || charCode > 57;
      if (isNotNumber) {
        event.preventDefault();
      }
      return true;
    },
    emitChange(event) {
      this.$emit("change", event);
    },
    focusOnInput(event) {
      const isNumber = event.keyCode >= 48 && event.keyCode <= 57;
      if (isNumber) {
        this.$refs.fieldSize.focus();
      }
    },
    created() {
      document.addEventListener("keydown", this.focusOnInput);
    },
    beforeUnmount() {
      document.removeEventListener("keydown", this.focusOnInput);
    },
  },
};
</script>

<style scoped></style>

